import React, { FC } from 'react';
import styled from 'styled-components';

const _HeadsetAccountMenu: FC<{ className?: string }> = ({ className }) => (
    <svg className={className} width='20' height='20' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M10 2.7981C6.2207 2.7981 3.125 5.8938 3.125 9.6731V13.4231C3.125 14.2312 3.65234 14.9197 4.375 15.1809V15.2981C4.375 17.0144 5.78369 18.4231 7.5 18.4231H8.30078C8.51807 18.7966 8.91357 19.0481 9.375 19.0481H10.625C11.3135 19.0481 11.875 18.4866 11.875 17.7981C11.875 17.1096 11.3135 16.5481 10.625 16.5481H9.375C8.91357 16.5481 8.51807 16.7996 8.30078 17.1731H7.5C6.46484 17.1731 5.625 16.3333 5.625 15.2981H6.875V9.6731H4.375C4.375 6.57739 6.9043 4.0481 10 4.0481C13.0957 4.0481 15.625 6.57739 15.625 9.6731H13.125V15.2981H15C16.0278 15.2981 16.875 14.4509 16.875 13.4231V9.6731C16.875 5.8938 13.7793 2.7981 10 2.7981ZM4.375 10.9231H5.625V14.0481H5C4.65332 14.0481 4.375 13.7698 4.375 13.4231V10.9231ZM14.375 10.9231H15.625V13.4231C15.625 13.7698 15.3467 14.0481 15 14.0481H14.375V10.9231Z'
            fill='#000000'
        />
    </svg>
);

const HeadsetAccountMenu = styled(_HeadsetAccountMenu)``;

export default HeadsetAccountMenu;
